import * as React from 'react';
import styled from 'styled-components';
import {AppAssetField} from '../../../components/media/AppAssetField';

interface AppAssetFieldsProps {
  iconFieldName: string;
  splashFieldName: string;
  iconUrl?: string | null;
  splashUrl?: string | null;
  iconError?: string | null;
  splashError?: string | null;
  appLabel?: string;
  accountPrimaryColor?: string;
  wallpaperLightUrl?: string;
  wallpaperDarkUrl?: string;
  cropIllustrationUrl?: string;
}
const Campos = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  margin: 20px 0 30px;
  @media (max-width: 800px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;
const AppAssetFields = (props: AppAssetFieldsProps) => (
  <Campos>
    <AppAssetField
      {...props}
      kind="icon"
      name={props.iconFieldName}
      url={props.iconUrl}
      error={props.iconError}
    />
    <AppAssetField
      {...props}
      kind="splash"
      name={props.splashFieldName}
      url={props.splashUrl}
      error={props.splashError}
      corInicial={props.accountPrimaryColor}
    />
  </Campos>
);
export default AppAssetFields;
